<template>
  <span class="text-red">*</span>
</template>
<script setup>
</script>
